import styled from 'styled-components'

import { FlexContainer } from '@/components'

type ServicesContainerProps = {
  darkMode?: boolean
}

const authorImageWidth = 150
const gapSize = 24

export const FlexContainerCases = styled(FlexContainer)`
  max-width: 1170px;

  @media (max-width: 1180px) {
    padding: 0 16px !important;
  }
`
export const CasesContainer = styled.div<ServicesContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${(props) => props.theme.colors.white};

  gap: ${gapSize}px;

  .pagination-container {
    margin-left: ${authorImageWidth + gapSize}px;
  }

  .testimonial-container {
    display: flex;
    flex-direction: column;
    gap: ${gapSize}px;
  }

  @media (max-width: 700px) {
    .pagination-container {
      margin-left: 0px;
    }
  }
`
